// @flow
import React, { Component } from 'react';
import { Form, Collapse, Alert } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import SliderInput from './components/SliderInput/SliderInput';
import style from './style/style';

import locale from '../../../../locales/index';

class speechAndLanguage extends Component<{
  user: Object,
}, {
 advanced: boolean,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      advanced: false,
    };
  }

  settings: Object;

  toggleAdvancedMode() {
    this.setState({ advanced: !this.state.advanced });
  }

  save(user: Object): Object {
    const newUser = user;
    newUser.settings = this.settings;
    return newUser;
  }

  render(): React.Node {
    this.settings = this.props.user.settings;

    return (<Form horizontal>
      <h4 style={style.title}>{locale.basicSettings}</h4>
      <SliderInput
        title={locale.speed}
        defaultValue={this.settings.avatar.speed}
        min={-10}
        max={10}
        onChange={(v) => { this.settings.avatar.speed = +v || 0; }}
      />
      <SliderInput
        title={locale.listenTime}
        defaultValue={this.settings.avatar.listenTime}
        min={5}
        max={60}
        onChange={(v) => { this.settings.avatar.listenTime = +v || 20; }}
      />
      <SliderInput
        title={locale.volume}
        defaultValue={this.settings.avatar.volume}
        min={0}
        max={100}
        onChange={(v) => { this.settings.avatar.volume = +v || 100; }}
      />

      <span onClick={() => this.toggleAdvancedMode()} role="button">
        <h4 style={style.collapse}>
          <FontAwesome name={this.state.advanced ? 'caret-down' : 'caret-right'} /> {locale.confidenceSettings}
        </h4>
      </span>

      <Collapse in={this.state.advanced}>
        <div>
          <Alert bsStyle="warning">
            <strong>{locale.dangerZoneTitle}</strong> {locale.confidenceWarning}
          </Alert>
          <SliderInput
            title={locale.confidenceActive}
            defaultValue={this.settings.avatar.confidence.active}
            min={0}
            max={10000}
            onChange={(v) => { this.settings.avatar.confidence.active = +v || 3000; }}
          />
          <SliderInput
            title={locale.confidenceIdle}
            defaultValue={this.settings.avatar.confidence.idle}
            min={0}
            max={10000}
            onChange={(v) => { this.settings.avatar.confidence.idle = +v || 3500; }}
          />
        </div>
      </Collapse>

    </Form>);
  }
}

export default speechAndLanguage;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/SpeechAndLanguage/SpeechAndLanguage.js